import React from 'react';
import styles from './UserCard.module.scss';

export interface UserCardProps {
    user: User;
    mode?: 'paciente' | 'usuário';
    onUserClick?: (user: User) => void;
}

const UserCard: React.FC<UserCardProps> = ({ user, mode = 'paciente', onUserClick }) => {
    const getInitials = (name?: string): string => {
        if (!name) return '';
        const nameParts = name.replace('(você)' , '').trim().split(' ');
        if (nameParts.length === 0) return '';
        if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
        return nameParts[0][0].toUpperCase() + nameParts[nameParts.length - 1][0].toUpperCase();
    };

    return (
        <div
            key={user.id}
            className={styles.userCard}
            onClick={() => onUserClick?.(user)}
        >
            <div className={styles.avatar}>
                <span>{getInitials(user.name)}</span>
            </div>
            <div className={styles.info}>
                <div className={styles.name}>{user.name}</div>
                <div className={styles.modified}>
                    {mode === 'usuário' ? "Modificado em" : "Última consulta"}: {user.modified ? new Date(user.modified).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : 'N/A'}
                </div>
            </div>
        </div>
    );
};

export default UserCard;
